import { useLayoutEffect, useState, type RefObject } from 'react';

export function useMeasuredWidth(ref: RefObject<HTMLElement | null>, enabled: boolean): number | undefined {
    const [width, setWidth] = useState<number | undefined>(undefined);

    useLayoutEffect(() => {
        if (!enabled) {
            return;
        }
        const node = ref.current;
        if (!node) return;
        const update = () => setWidth(node.getBoundingClientRect().width);
        update();
        const ro = new ResizeObserver(update);
        ro.observe(node);
        return () => ro.disconnect();
    }, [enabled, ref]);

    return width;
}
